import lodash from "lodash";
import { useSelector } from "react-redux";
import {
  taskEffortAllSelector,
  taskEffortCountDenySelector,
  taskEffortCountPassSelector,
  taskEffortCountWarnSelector,
  taskEffortSumEaseSelector,
  taskEffortSumEffortSelector,
  taskEffortSumExpSelector,
  taskEffortSumMistakeSelector,
} from "store/bailiff/task/effort/task_effort.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useEffort = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const pass = useSelector(taskEffortCountPassSelector);
  const warn = useSelector(taskEffortCountWarnSelector);
  const deny = useSelector(taskEffortCountDenySelector);

  //statis
  const effort = useSelector(taskEffortSumEffortSelector);
  const exp = useSelector(taskEffortSumExpSelector);
  const ease = useSelector(taskEffortSumEaseSelector);
  const mistake = useSelector(taskEffortSumMistakeSelector);
  //count
  console.log({ pass, warn, deny, effort, exp, ease, mistake });

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { effort, exp, ease, mistake, pass, warn, deny };
};

// refine data effort.
export const useActionEffortRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(taskEffortAllSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};
